import React from 'react';
import { toastr } from 'react-redux-toastr';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import { deleteRequest } from '../../../lib/apiUtils';

export default class FlushAiSummaries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            loading: false,
            error: ''
        };
    }

    async flushAiSummaries() {
        this.setState({ loading: true });

        const response = await deleteRequest('/applications/summaries/flush');

        if (response.success) {
            this.setState({ loading: false });
            toastr.success('AI summaries cleared', response.data.message);
        } else {
            this.setState({ loading: false, error: response.message || 'Something went wrong.  Please try again.' });
        }

        return response.success;
    }

    render() {
        return (
            <div>
                <label className="input-label">AI Summaries</label>
                <p className="medium-text">Clear all cached AI summaries so they regenerate with the latest agent instructions.</p>
                <button className="btn btn-accent2" onClick={() => this.setState({ showModal: true })}>Clear AI Summary Cache</button>

                <ConfirmationModal
                    show={this.state.showModal}
                    title="Clear AI Summaries"
                    message="This will delete all cached AI summaries. They will regenerate automatically as summaries are viewed. Continue?"
                    close={() => this.setState({ showModal: false })}
                    confirm={this.flushAiSummaries.bind(this)}
                    loading={this.state.loading}
                    errorMessage={this.state.error}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/FlushAiSummaries.jsx